import { ContactUsPage, SubOffices } from '@pages/ContactUs/ContactUs.types';
import React from 'react';
import '../ContactUsSideView/ContactUsSideView.scss';

interface ContactOfficeViewProps {
  subOfficeList: SubOffices;
  pageLabels: ContactUsPage;
  onShowFindContactsBtnClick: () => void;
}

export const ContactOfficeView = ({
  subOfficeList,
  pageLabels,
  onShowFindContactsBtnClick,
}: ContactOfficeViewProps) => {
  return (
    <>
      {Object.entries(subOfficeList)?.map(([key, value]) => {
        const officeType = key ? key.split('|') : '';
        if (officeType[1]?.trim() == 'Main office' && value && Array.isArray(value)) {
          return (
            <div key={key} className='c-contact-main-office-section'>
              <p className='c-contact-main-office-section-title'>{officeType ? officeType[0] : ''}</p>
              {value.length > 0 && (
                <div className='c-contact-main-office'>
                  {value.map((e, index) => {
                    if (e) {
                      return (
                        <div className='c-contact-main-office-list' key={index}>
                          <div className='c-contact-heading-font'>
                            <p>{e.OfficeName}</p>
                          </div>
                          <div className='labels-font' key={index.toString()}>
                            <p>{e.Address1}</p>
                            <p>{e.Address2}</p>
                            <p>{e.Address3}</p>
                            {e.Postal && <p>{e.Postal}</p>}
                            {e.City && <p>{e.City}</p>}
                            {e.State && <p>{e.State}</p>}
                            {e.PhoneNumber && e.PhoneNumber.trim() !== '' && (
                              <p>
                                {e.PhoneLabel && <span>{e.PhoneLabel}: </span>}
                                <a href={'tel:' + e.PhoneNumber}>{e.PhoneNumber}</a>
                              </p>
                            )}
                            {e.Fax && e.Fax != '' && (
                              <p>
                                {e.FaxLabel}: {e.Fax}
                              </p>
                            )}
                            {e.EmailAddress && e.EmailAddress.trim() !== '' && (
                              <p>
                                {e.EmailLabel && <span>{e.EmailLabel}: </span>}
                                <a href={'mailto:' + e.EmailAddress}>{e.EmailAddress}</a>
                              </p>
                            )}
                          </div>
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
              )}
            </div>
          );
        }
      })}
      <div className="c-contact-info-wrapper">
        <a className='c-contact-color-labels' onClick={onShowFindContactsBtnClick}>
          {pageLabels.FindYourContactsLinkText}
        </a>
        <br />
        <h4 className='partner-label'>{pageLabels.PartnersLabel}</h4>
        <p className='partner-description'>{pageLabels.PartnerDescription}</p>
        <br />
        <a href={pageLabels.PartnerLink} target='_blank' rel='noreferrer'>
          <span className='c-contact-color-labels'>{pageLabels.FindYourPartnerLinkText}</span>
        </a>
      </div>
    </>
  );
};
